import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { makeStyles, Theme } from '@material-ui/core';
import { SuggestionCardIcon, SuggestionCardIconHover } from '@assets';
import { useState } from 'react';

export interface ServiceSurveyCardProps {
  bgcolor?: string;
  width?: number;
  height?: number;
}

const ServiceSurveyCard = ({
  bgcolor = colorSet.gray100,
  width = 200,
  height = 225
}: ServiceSurveyCardProps) => {
  const { suggestionCard } = useServiceSurveyCardStyles({
    bgcolor,
    width,
    height
  });
  const [isSuggestHover, setIsSuggestHover] = useState<boolean>(false);

  return (
    <div
      className={suggestionCard}
      onMouseEnter={() => {
        setIsSuggestHover(true);
      }}
      onMouseLeave={() => {
        setIsSuggestHover(false);
      }}
      onClick={() =>
        window.open(
          'https://forms.office.com/Pages/ResponsePage.aspx?id=YgkiXAnoSU-_A-gopRvcT5MMzuCY1N5IislpZIGwDl1UM0hXSzE5VDlQR01WRUo3QzFGU1lYUkhQOS4u'
        )
      }
    >
      <div className="circle">
        <img
          src={!isSuggestHover ? SuggestionCardIcon : SuggestionCardIconHover}
          width={72}
          height={72}
          alt="serviceSuggestion"
        />
      </div>
      <CustomizedTypography
        variant="subtitle1"
        color="textSecondary"
        className="suggestionText"
      >
        원하는 서비스가
        <br />
        없나요?
      </CustomizedTypography>
    </div>
  );
};

const useServiceSurveyCardStyles = makeStyles<Theme, ServiceSurveyCardProps>({
  suggestionCard: {
    width: ({ width }) => width,
    height: ({ height }) => height,
    borderRadius: '16px',
    backgroundColor: ({ bgcolor }) => bgcolor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '& .circle': {
      border: `4px solid ${colorSet.gray100}`,
      backgroundColor: colorSet.gray600,
      width: 75,
      height: 75,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      marginBottom: 20
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: colorSet.gray200,
      '& .circle': {
        backgroundColor: colorSet.gray700
      },
      '& .suggestionText': {
        color: colorSet.gray900
      }
    }
  }
});

export default ServiceSurveyCard;
